import { useLocation } from "react-router-dom";
import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { isContinuityCompleted, getFormattedDate } from "../../../util/dates";
import { updatePatientsInfo, getPatient } from "../../../db/users";
import Container from "../../../ui/Container/Container";
import List from "../../../ui/List/List";
import ExtraOptions from "../ExtraOptions/ExtraOptions";
import "./PatientInfo.css";

function PatientInfo() {
  const authCtx = useContext(AuthContext);
  const location = useLocation();
  const [patient, setPatient] = useState();
  const [isFetching, setIsFetching] = useState(true);
  const [followContinuity, setFollowContinuity] = useState(false);
  const [finalContinuity, setFinalContinuity] = useState(false);

  useEffect(() => {
    async function fetchPatient() {
      setIsFetching(true);
      const response = await getPatient(
        authCtx.userId,
        location.state.patientKey,
        authCtx.token
      );
      if (!response.data) {
        setIsFetching(false);
      } else {
        const fetchedPatient = response.data;
        fetchedPatient.isInitialCompleted = true;
        if (fetchedPatient.forceFollowContinuity) {
          setFollowContinuity(true);
        } else {
          setFollowContinuity(
            isContinuityCompleted(new Date(fetchedPatient.patientInitDate), 20)
          );
        }
        if (fetchedPatient.forceFinalContinuity) {
          setFinalContinuity(true);
        } else {
          setFinalContinuity(
            isContinuityCompleted(new Date(fetchedPatient.patientInitDate), 70)
          );
        }
        setPatient(fetchedPatient);
        setIsFetching(false);
      }
    }
    try {
      fetchPatient();
    } catch (error) {
      console.log(error);
    }
  }, [location.state.patientKey]);

  function generateQuestionariesData() {
    const data = [
      {
        enabled: !patient.patientAgreed,
        useContinuity: true,
        key: "ci",
        value: "Consentimiento Informado",
        navigateTo: "/ci",
        route: {
          patient: patient,
          doctor: authCtx.currentDoctor,
          navigateTo: "/patientInfo",
        },
      },
      {
        key: "initial",
        value: "Información inicial",
        navigateTo: "/showResults",
        route: {
          patient: patient,
          key: "initial",
          navigateTo: "/patientInfo",
          patientKey: location.state.patientKey,
        },
      },
      {
        key: "follow",
        value: !patient
        ? "Información de seguimiento"
        : `Información de seguimiento - ${getFormattedDate(
            new Date(patient.followDate)
          )} - consulta intermedia a los 30 días`,
        enabled: followContinuity,
        useContinuity: true,
        navigateTo: !patient.isFollowCompleted
          ? "/showQuestionary"
          : "/showResults",
        route: {
          patient: patient,
          key: "follow",
          navigateTo: "/patientInfo",
          patientKey: location.state.patientKey,
        },
      },
      {
        enabled: finalContinuity,
        useContinuity: true,
        key: "final",
        value: !patient
        ? "Cuestionario final"
        : `Cuestionario final - ${getFormattedDate(new Date(patient.endDate))} - consulta final a los 90 días`,
        navigateTo: !patient.isFinalCompleted
          ? "/showQuestionary"
          : "/showResults",
        route: {
          patient: patient,
          key: "final",
          navigateTo: "/patientInfo",
          patientKey: location.state.patientKey,
        },
      },
    ];
    return data;
  }

  if (isFetching) {
    return <p>Cargando...</p>;
  }

  if (patient) {
    return (
      <Container title="Paciente" backNavigation={"/mainDoctor"}>
        <div>
          <p className="patientInfoName">{patient.patientName}</p>
        </div>
        <List data={generateQuestionariesData()} height="36%" />
        <ExtraOptions patientId={patient.key} />
      </Container>
    );
  }
}

export default PatientInfo;
